import { Icon } from "@iconify/react";
import React from "react";
import { useNavigate } from "react-router-dom";

export default function DashboardQuickActions() {
  const navigate = useNavigate();

  return (
    <div className="dashboard-quick-grid">
      <div className="quick-action-card">
        <div className="quick-action-icon">
          <Icon icon="pajamas:documents" width="24" height="24" />
        </div>
        <div className="quick-action-content">
          <h3 className="quick-action-title">Go to Documents</h3>
          <p className="quick-action-text">
            Upload a new PDF or open an existing document workspace.
          </p>
        </div>
        <button
          className="btn btn-primary"
          onClick={() => navigate("/documents")}
        >
          Open Documents
        </button>
      </div>

      <div className="quick-action-card">
        <div className="quick-action-icon">
          <Icon icon="icon-park-solid:analysis" width="24" height="24" />
        </div>
        <div className="quick-action-content">
          <h3 className="quick-action-title">Open Analytics</h3>
          <p className="quick-action-text">
            Review signer engagement, SLA metrics, and drop-off behavior.
          </p>
        </div>
        <button
          className="btn btn-primary"
          onClick={() => navigate("/analytics")}
        >
          View Analytics
        </button>
      </div>
    </div>
  );
}
